import React from 'react';
import { motion } from 'framer-motion';
export function ImpactPhrases() {
  const phrases = ['La culpa no alimenta. El sistema sí.', 'Tu hijo no es difícil. La improvisación sí lo es.', '30 minutos de planificación. 7 días de tranquilidad.', 'No se trata de cocinar perfecto. Se trata de cocinar consciente.', 'El rechazo en la mesa no es sobre la comida. Es sobre el control.', 'Un niño que come bien no nace. Se construye, con constancia y calma.', 'Nadie te enseñó a organizar la alimentación infantil. Eso termina hoy.', 'El equilibrio no se mide en platos. Se mide en semanas.', 'Tu rol es ofrecer. El suyo es decidir. Cuando eso queda claro, la pelea se acaba.', 'No necesitas más recetas. Necesitas un sistema.'];
  return <section className="py-16 px-4 bg-[#FFF8F0] overflow-hidden" data-id="element-474">
      <div className="max-w-lg md:max-w-5xl mx-auto" data-id="element-475">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-476">
          {phrases.map((phrase, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx % 5 * 0.1
        }} className="bg-white p-6 rounded-2xl shadow-sm border border-[#FFE0B2] flex items-center" data-id="element-477">
              <p className="text-lg font-bold text-[#D84315] italic" data-id="element-478">
                "{phrase}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}